import React from 'react';
import styled from 'styled-components';

const Main = styled.main``;
const Section = styled.section``;

const Navigation = styled.ul`
  list-style: none;
  display: flex;
  width: 100%;
  justify-content: space-between;
  margin: 0 auto;
  padding: 20px;

  @media screen and (max-width: 768px) {
    margin-bottom: 10px;
    padding: 0px;
  }
`;

const Alphabet = styled.li`
  color: #2b2b2b;
  font-size: 24px;
  line-height: 30px;

  a {
    text-decoration: none;
    color: #2b2b2b;

    :hover {
      color: #b10029;
    }
  }

  span {
    color: #eaeaea;
  }

  @media screen and (max-width: 768px) {
    font-size: 16px;
    padding-right: 3px;
    line-height: 22px;
  }
`;

const Letter = styled.p`
  font-size: 24px;
  line-height: 30px;
  color: #005d71;
  padding: 0;

  @media screen and (max-width: 768px) {
    font-size: 20px;
    margin: 14px 0px 0px 0px;
  }
`;

const List = styled.ul`
  list-style: none;
  margin: 0;
  columns: 4;
  padding: 0;

  @media screen and (max-width: 768px) {
    columns: 2;
    font-size: 14px;
  }

  @media screen and (max-width: 768px) {
    columns: 3;
  }
`;

const Cell = styled.li`
  line-height: 20px;
  margin-bottom: 10px;

  a {
    text-decoration: none;
    color: #2b2b2b;

    :hover {
      color: #005d71;
      text-decoration: underline #005d71;
    }
  }

  @media screen and (max-width: 768px) {
    margin-bottom: 5px;
  }
`;

const alphabet = [...'ABCDEFGHIJKLMNOPQRSTUVWYZ#'];

const Street = ({ data }) => {
  const lettersWithData = data.itemGroups.map(itemGroup => {
    if (itemGroup.seoPageItems !== null) return itemGroup.itemGroupLabel;
    return '';
  });

  const hasDataForLetter = letter => lettersWithData.includes(letter);

  const handleClick = e => {
    const url = e.currentTarget.dataset.href;
    window.location.href = url;
  };

  return (
    <>
      <Navigation>
        {alphabet.map(letter => (
          <Alphabet key={letter}>
            {hasDataForLetter(letter) && <a href={`#${letter}`}>{letter}</a>}
            {!hasDataForLetter(letter) && letter !== '#' && <span>{letter}</span>}
          </Alphabet>
        ))}
      </Navigation>
      <Main>
        {data.itemGroups &&
          data.itemGroups.map(value =>
            value.seoPageItems !== null ? (
              <Section key={value} id={value.itemGroupLabel}>
                <Letter>{value.itemGroupLabel}</Letter>
                <List>
                  {value.seoPageItems &&
                    value.seoPageItems.map(street => (
                      <Cell key={street}>
                        {street.obfuscated ? (
                          <button
                            type="button"
                            onClick={handleClick}
                            data-href={street.saleUrl}
                            style={{
                              background: 'none',
                              border: 'none',
                              padding: 0,
                              margin: 0,
                              cursor: 'pointer',
                              font: 'inherit',
                            }}
                          >
                            {street.name}
                          </button>
                        ) : (
                          <a href={street.saleUrl}>{street.name}</a>
                        )}
                      </Cell>
                    ))}
                </List>
              </Section>
            ) : (
              <></>
            ),
          )}
      </Main>
    </>
  );
};

export default Street;
